export default __webpack_public_path__ + "static/media/e-adhigam-progress-logo.d83af33b.png";